@import 'styles/mixins';
@import 'styles/variables';

div.modalWrapper {
  min-width: auto;
  width: 903px;
  transition: all 2s;

  .modalHeader {
    @include xxl-semibold;
    border-bottom: none;
  }

  .modalBody {
    padding-top: 24px;
    padding-left: 0px;
    padding-right: 0px;
  }

  &.extended {
    width: 1100px;
  }
}

.handbookSettings {
  display: block;

  fieldset {
    justify-content: center;
    display: flex;
    margin-bottom: 24px;
    flex-direction: column;
  }

  label {
    @include sm-regular;

    color: $grey-40;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    span {
      @include ui-sm-text;

      color: $grey-40;
    }
  }

  hr.divider {
    border: 0;
    border-top: 1px solid $grey-20;
    margin: 0 -16px 24px -16px;
  }

  hr.footerDivider {
    border: 0;
    border-top: 2px solid $grey-5;
    margin: 0 -24px 16px -24px;
  }

  .nameInput {
    @include md-regular;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: unset;

    border: 1px solid $grey-10;
    border-radius: 4px;
    color: $grey-90;
    flex-grow: 1;
    padding: 3px;
    width: 400px;
    height: 36px;

    .innerInput {
      width: 400px;
    }

    &::placeholder {
      color: $grey-40;
    }

    &.focused {
      border-color: var(--focus-50);
      box-shadow: 0px 0px 0px 3px var(--focus-5);
    }
  }

  .submitButton {
    margin-left: auto;
  }

  .settingsOption {
    .toggleRow {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    .helpText {
      color: $grey-40;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      margin-top: 8px;
      width: 75%;
    }

    .optionHeader {
      @include ui-lg-bold;

      color: $grey-90;
    }

    .inputRow {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .nameEmojiInput {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: unset;
  }
}

.errorMessage {
  @include ui-sm-text;

  color: $red-50;
  margin-top: 4px;
}

.innerContainer {
  display: flex;
  flex-direction: row;
}

.navigation {
  @include ui-md-semibold;

  width: 144px;
  margin: 0 8px;
}

.sections {
  @include customScrollbar;

  max-height: 90vh;
  height: 555px;
  overflow-y: scroll;
  padding-right: 24px;
  position: relative;
  width: 100%;
  @include scroll-behavior-smooth;
}

.sectionTitle {
  @include xl-semibold;
  margin-bottom: 24px;
  margin-left: 20px;
}

.sectionSubtitle {
  @include md-regular;
  color: $grey-40;
}

.divider {
  background: $grey-10;
  height: 1px;
  margin: 44px 24px;
}

.row {
  display: grid;
  grid-template-columns: minmax(200px, 600px) auto;
  justify-content: space-between;
  margin-bottom: 24px;

  &.disabled {
    opacity: 0.3;
  }
}

.marginLeft {
  margin-left: 20px;
}

.mb32 {
  margin-bottom: 24px;
}

.label {
  @include lg-medium;
  color: $grey-90;
}

.subLabel {
  @include md-regular;
  color: $grey-40;
  margin-top: 4px;
}

.selectContainer {
  position: relative;
}

.select {
  width: 160px;
  background: #ffffff;
  border: 1px solid $grey-20;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 16px;
  height: 36px;

  &:hover {
    background: #ffffff;
    border-color: $grey-40;
  }

  &:focus,
  &:active {
    border-color: var(--focus-50);
    box-shadow: 0px 0px 0px 3px var(--focus-5);
  }

  svg {
    flex: none !important;
  }
}

// publish styles

.publishCard {
  position: relative;
  box-shadow: 0px 1px 1px rgba(19, 21, 26, 0.12), 0px 8px 24px rgba(19, 21, 26, 0.12);
  border-radius: 8px;
  margin-bottom: 32px;
  padding-top: 32px;

  .header {
    @include xl-semibold;
    color: $grey-90;
    text-align: center;
    margin-bottom: 0;
  }

  .subheader {
    @include sm-regular;
    color: $grey-40;
    text-align: center;
    max-width: 410px;
  }

  .mt18 {
    margin: 18px auto;
  }

  .mt24 {
    margin: 24px auto;
  }

  .mt32 {
    margin: 32px auto;
  }

  .mb16 {
    margin-bottom: 16px;
  }

  .publishedMeta {
    @include md-regular;
    color: $grey-90;
    text-align: center;
  }

  .previewImg {
    display: block;
    margin: 0 auto;
  }

  .footer {
    @include sm-regular;
    color: $grey-40;
    padding: 12px 24px;
    box-shadow: inset 0px 1px 0px rgba(19, 21, 26, 0.12);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .publishedFooter {
    padding-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .unpublishBtn,
  .updateBtn .publishBtn {
    width: 160;
  }

  .unpublishBtn {
    margin-left: 16px;
  }

  .publicLink {
    @include md-medium;
    align-items: center;
    border-radius: 4px;
    color: $blue-50;
    cursor: pointer;
    display: flex;
    letter-spacing: 0.01em;
    padding: 6px 8px;
    text-align: center;
    width: fit-content;

    &:hover {
      background: rgba(19, 21, 26, 0.05);
    }
  }

  .linkIcon {
    fill: $blue-50;
    height: 16px;
    width: 16px;
    margin-left: 6px;
  }
}

.deleteHandbook {
  .subLabel {
    margin-bottom: 24px;
  }

  margin-bottom: 397px;
}

.rejectIcon {
  fill: $green-60;
}

.share {
  padding: 0;
}

.toggle {
  margin-top: 12px;
}
